<img *ngFor="let img of shelf.images" [src]="img.url" [alt]="img.alt" (click)="redirect(img.redirectUrl)" />